import React, { useState } from "react";
import PropTypes from "prop-types";
import QrReader from "react-qr-reader";
import { getParkingStickers } from "../../../services/api/parkingVouchers";
import { selectEvent } from "../../../redux/preferences/selectors";
import connect from "react-redux/es/connect/connect";
import { Link } from "react-router-dom";

const _ParkingStickersScan = ({ event }) => {
  const [code, setCode] = useState();
  const [loading, setLoading] = useState(false);
  const [sticker, setSticker] = useState();

  const handleScan = data => {
    if (data && !loading && code !== data) {
      setCode(data);
      setLoading(true);
      getParkingStickers(event.id, {
        "filter[code]": parseInt(data),
        include:
          "crew-member,crew-member.user,crew-member.registration,crew-member.registration.company,parking-sticker.parking"
      })
        .then(response => {
          if (response.data.length > 0) {
            setSticker(response.data[0]);
          } else {
            alert("code not found");
          }

          setLoading(false);
        })
        .catch(e => {
          alert("error");
        });
    }
  };

  return (
    <div className="qr-container">
      <QrReader
        delay={300}
        onError={error => console.error(error)}
        onScan={handleScan}
        style={{ width: "100%" }}
        className="qr-scanner"
      />

      <div className="m-content">
        {sticker && (
          <div>
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-user" />
                    </span>
                    <h3 className="m-portlet__head-text">Sticker Info</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                <strong>Company: </strong>{" "}
                {sticker.crewMember.registration.company.name} <br />
                <strong>Crew Member: </strong>{" "}
                {sticker.crewMember.user.firstName}{" "}
                {sticker.crewMember.user.lastName}
                <br />
                <strong>Crew Member Phone: </strong>{" "}
                {sticker.crewMember.user.telephone}
                <br />
                <strong>Crew Member Email: </strong>{" "}
                {sticker.crewMember.user.email}
                <br />
              </div>

              <div className="m-portlet__foot">
                <div className="row align-items-center">
                  <div className="col-lg-12 m--align-right">
                    <Link
                      to={
                        "/admin/registrations/" +
                        sticker.crewMember.registration.id +
                        "/edit"
                      }
                      className="btn m-btn btn-primary"
                    >
                      Go To Registration
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

_ParkingStickersScan.propTypes = {
  event: PropTypes.object
};

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state)
  };
};

const ParkingStickersScan = connect(
  mapStateToProps,
  mapDispatchToProps
)(_ParkingStickersScan);

export default ParkingStickersScan;
